<template>
    <div class="row">
        <div class="col-sm-12 text-center" style="padding-top: 0;padding-bottom: 0;">
            <xstek-audio-recorder :after-xstek-recording="afterXstekRecording"></xstek-audio-recorder>
        </div>
        <div class="col-sm-12" v-show="uploading" style="padding-top: 0;padding-bottom: 0;">
            <v-progress-linear v-model="uploading_progress"></v-progress-linear>
        </div>
        <div class="col-sm-12" style="padding-top: 0;">
            <div class="row recorded-dictation-grid" style="overflow:scroll; overflow-x: hidden;overflow-y: auto;">
                <div class="col-12" style="padding-top: 0;">
                    <div class="row recorded-grid-heading blue-header" style="font-weight: 600;font-size: 9pt;padding: 5px 12px 5px 12px;">
                        <div class="col-3">
                            <span>Urgent</span><span style="text-align: center;display: inline-block;width: 79%;">File Name</span>
                        </div>
                        <div class="col-2" style="text-align: center;">
                            Dictator
                        </div>
                        <div class="col-1" style="text-align: center;">
                            Account
                        </div>
                        <div class="col-1" style="text-align: center;">
                            Patient No.
                        </div>
                        <div class="col-2" style="text-align: center;">
                            Patient First Name
                        </div>
                        <div class="col-2" style="text-align: center;">
                            Patient Last Name
                        </div>
                        <div class="col-1" style="text-align: center;">
                            Options
                        </div>
                    </div>
                    <div class="row dictation" ref="recorded" v-on:click="selectDictation(index, $data)" v-for="(dictation, index) in recorded" :key="index">
                        <div class="input-group col-3">
                            <div class="input-group-prepend">
                                <div class="input-group-text">
                                    <input v-model="dictation.urgent" type="checkbox" title="Mark as urgent" />
                                </div>
                            </div>
                            <input name="fileName" placeholder="File Name" class="form-control form-control-sm" type="text" v-model.trim="dictation.fileName" />
                        </div>
                        <div class="col-2">
                            <input placeholder="Dictator Name" class="form-control form-control-sm" type="text" v-model.trim="dictation.cliName" readonly />
                        </div>
                        <div class="col-1">
                            <input class="form-control form-control-sm" type="text" v-model.trim="dictation.hosShortName" readonly />
                        </div>
                        <div class="col-1">
                            <input maxlength="50" placeholder="Patient No." class="form-control form-control-sm" type="text" v-model.trim="dictation.patientNo" />
                        </div>
                        <div class="col-2">
                            <input maxlength="50" placeholder="Patient First Name" class="form-control form-control-sm" type="text" v-model.trim="dictation.firstName" />
                        </div>
                        <div class="col-2">
                            <input maxlength="50" placeholder="Patient Last Name" class="form-control form-control-sm" type="text" v-model.trim="dictation.lastName" />
                        </div>
                        <div class="col-1" style="margin-top: 5px;text-align: center;">
                            <button type="button" class="btn-outline-none" v-on:click="playRecordedDictation(dictation)" title="Play Dictation">
                                <i class="far fa-play-circle" aria-hidden="true" style="cursor:pointer;"></i>
                            </button>
                            <button type="button" class="btn-outline-none" v-on:click="downloadRecordedDictation(dictation)" style="margin-left: 5px;" title="Download Dictation">
                                <i class="fas fa-download" style="cursor: pointer;"></i>
                            </button>
                            <button type="button" class="btn-outline-none" v-on:click="removeRecordedDictation(index, dictation)" style="margin-left: 5px;" title="Delete Dictation">
                                <i class="far fa-trash-alt" style="cursor: pointer;"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //uncomment for vuex state management
    //import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
    import XstekAudioRecorder from './XstekAudioRecorder';
    import axios from 'axios'
    import moment from 'moment'
    import jQuery from 'jquery'
    let $ = jQuery
    export default {
        //Your local variables for use in the component
        data() {
            return {
                isRecordingSupported: false,
                uploading: false,
                uploading_progress: 0,
                recorded: [],
            };
        },
        async created() {
            if (!navigator.mediaDevices) {
                this.isRecordingSupported = false;
            } else {
                this.isRecordingSupported = true;
            }
        },
        //calculated values, auto reactive
        //functionName: function(){}
        //functionName: { get: function() {}, set: function(value){}}
        computed: {},
        //perform actions, not reactive to variables used
        //functionName: function(arg1,arg2){}
        methods: {
            afterXstekRecording($event) {
                try {
                    if (!this.recorded) {
                        this.recorded = [];
                    }
                    let duration = $event.duration.split(':');
                    let fileName = `${moment().format("DDMMYYYY-HHmmss")}`;
                    this.recorded.push({
                        "src": $event.url,
                        "blob": $event.blob,
                        "hosID": this.hosID,
                        "hosShortName": this.hosShortName,
                        "cliID": this.cliID,
                        "cliName": this.cliName,
                        "fileName": fileName,
                        "fileExtension": '.mp3',
                        "patientNo": null,
                        "firstName": null,
                        "lastName": null,
                        "urgent": false,
                        "duration": ((+duration[0]) * 60 + (+duration[1])) + 1,
                    });
                    // select last recorded voice
                    this.$nextTick(() => {
                        this.$refs.recorded[this.recorded.length - 1].click();
                        setTimeout(() => {
                            $(".recorded-dictation-grid").animate({ scrollTop: $('.recorded-dictation-grid').prop("scrollHeight") }, 1000);
                        }, 100);
                    });
                }
                finally {
                    $('.ar-recorder__stop').removeAttr('title');
                    if (this.onRecordingChange) {
                        this.onRecordingChange((this.recorded && this.recorded.length > 0) ? false : true);
                    }
                }
            },
            selectDictation(index) {
                $(".dictation").removeClass("dictation-active");
                $(".dictation").eq(index).addClass("dictation-active");
            },
            playRecordedDictation(recordedDictation) {
                window.open(recordedDictation.src);
            },
            downloadRecordedDictation(recordedDictation) {
                let fileLink = document.createElement('a');
                fileLink.href = recordedDictation.src;
                fileLink.setAttribute('download', recordedDictation.fileName);
                document.body.appendChild(fileLink);
                fileLink.click();
            },
            removeRecordedDictation(index, dictation) {
                this.$confirm(`Are you sure you want to delete this "${dictation.fileName}" dictation?`, "Confirm", "warning").then(() => {
                    this.recorded.splice(index, 1);
                    if (this.$refs.recorder) {
                        this.$refs.recorder.removeRecord(index);
                    }
                    $(".dictation").removeClass("dictation-active");
                })
                    .catch(() => { })
                    .finally(() => {
                        if (this.onRecordingChange) {
                            this.onRecordingChange((this.recorded && this.recorded.length > 0) ? false : true);
                        }
                    });
            },
            uploadDictations() {
                /* Initialize the form data */
                let formData = new FormData();
                /*
                  Iteate over any file sent over appending the files
                  to the form data.
                */

                let voicesInfo = [];
                for (var i = 0; i < this.recorded.length; i++) {
                    if (!this.recorded[i].fileName) {

                        this.recorded[i].fileName = moment().format("MMDDYYYY-HHmmss");
                    }
                    formData.append('files[' + i + ']', this.recorded[i].blob, this.recorded[i].fileName);
                    voicesInfo.push(Object.assign({}, this.recorded[i]));
                }
                formData.append("voicesInfo", JSON.stringify(voicesInfo));
                formData.append("hosID", this.hosID);
                formData.append("hosShortName", this.hosShortName);
                formData.append("cliID", this.cliID);
                formData.append("clinicDate", moment().format("YYYY/MM/DD"));
                formData.append("recorded", true);
                this.uploading = true;
                this.uploading_progress = 0;
                if (!this.axios.defaults.headers['Authorization'] && this.$store) {
                    this.axios.defaults.headers['Authorization'] = `Bearer ${this.$store.state.token}`;
                }
                axios.post('api/dictation/upload', formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                        maxContentLength: Infinity,
                        maxBodyLength: Infinity,
                        onUploadProgress: (progressEvent) => {
                            this.uploading_progress = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
                        }
                    }
                ).then(() => {
                    this.recorded = [];
                    if (this.onAfterUpload) {
                        this.onAfterUpload();
                    }
                }).catch((e) => {
                    this.$alert("Something went wrong. Please try again later.");
                    if (this.onErrorUpload) {
                        this.onErrorUpload(e);
                    }
                }).finally(() => {
                    this.uploading = false;
                    this.uploading_progress = 0;
                });
            },
        },
        /*  data passed in from external
        propName: {
            type: Number,
            default: 42,
            required: false
        }
        */
        props: {
            hosID: { type: String },
            hosShortName: { type: String },
            cliID: { type: String },
            cliName: { type: String },
            onRecordingChange: { type: Function },
            onBeforeUpload: { type: Function },
            onAfterUpload: { type: Function },
            onErrorUpload: { type: Function },
        },
        /* other components need
          you need to import the component first
          'component-a': ComponentA,
        */
        components: {
            XstekAudioRecorder
        }
    };
</script>

